import React, { useMemo, useState } from 'react'
import { Close, Hamburger } from '@dasa-health/alma-icons'
import { Button, LinkInline } from '@dasa-health/alma-react'
import { Divider, Icon } from '@dasa-health/components-react'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { NavConteudoLinkBuilded, RedirectToCOABuilded } from '@nsw-paginas-deslogadas/utils'
import { Images, BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { dataAtributtesType } from '../Header'
import * as S from './styles'
import { actionsText } from '@nsw-paginas-deslogadas/constants'

export type MenuItem = {
    id: number
    text: string
    link: string
    dataAtribute: dataAtributtesType
}

export type MenuProps = {
    showMenuAccount: boolean
    dataAtributtes: (dataText: string) => dataAtributtesType
}

export const Menu: React.FC<MenuProps> = ({ showMenuAccount, dataAtributtes }) => {
    const { WhiteNavDasaLogo } = Images

    const { brand, product } = useAppContext()
    const [dropdown, setDropdown] = useState(false)
    const mapping = BrandMapping[brand.mappingId]

    const menuProps = useMemo<{ menuItems: MenuItem[] }>(
        () => ({
            menuItems: [
                {
                    id: 1,
                    link: NavConteudoLinkBuilded,
                    text: 'Conteúdo',
                    dataAtribute: dataAtributtes('Hub de Conteúdo'),
                },
                {
                    id: 2,
                    link: RedirectToCOABuilded,
                    text: 'Consulta Online',
                    dataAtribute: dataAtributtes('COA'),
                },
            ],
        }),
        [dataAtributtes],
    )

    const productLabels = useMemo(() => (product.category?.id === 4 ? actionsText.vaccines : actionsText.exams), [product])

    return (
        <S.Container showMenuAccount={showMenuAccount}>
            <Icon onClick={() => setDropdown(true)} size={24}>
                <Hamburger data-testid="icon-open-dropdown" />
            </Icon>
            <div className={`${dropdown ? 'dropdown-conta active' : ''}`}>
                {dropdown && (
                    <S.MenuList data-testid="menu-conta-dropdown" {...menuProps}>
                        <S.ContainerCloseDropdownIcon>
                            <Icon
                                className="closeDropdownBold"
                                data-testid="close-menu-icon"
                                onClick={() => setDropdown(false)}
                                size={24}
                            >
                                <Close />
                            </Icon>
                        </S.ContainerCloseDropdownIcon>

                        <S.MenuContentContainer>
                            <S.HeaderLogo alt={WhiteNavDasaLogo.alt} src={WhiteNavDasaLogo.src} />
                            <Divider sx={{ marginBottom: '2rem' }} />
                            {menuProps.menuItems.map(item => (
                                <S.MenuListItem key={item.id}>
                                    <LinkInline
                                        href={`${item.link}`}
                                        style={{ textDecoration: 'none' }}
                                        target="_blank"
                                        {...item.dataAtribute}
                                    >
                                        <div>
                                            <p>{item.text}</p>
                                        </div>
                                    </LinkInline>
                                </S.MenuListItem>
                            ))}

                            <Divider />
                            <S.ButtonContainer>
                                {product?.category ? (
                                    <a
                                        data-testid="btn-vaccine"
                                        href={product.navigateTo}
                                        target="_self"
                                        {...dataAtributtes(productLabels.plural)}
                                    >
                                        <Button>{productLabels.single}</Button>
                                    </a>
                                ) : (
                                    <>
                                        {mapping.vaccine && (
                                            <a
                                                data-testid="btn-vaccine"
                                                href={mapping.buttons.header.vaccines}
                                                target="_self"
                                                {...dataAtributtes(actionsText.vaccines.plural)}
                                            >
                                                <Button>{actionsText.vaccines.single}</Button>
                                            </a>
                                        )}
                                        <a
                                            data-testid="btn-exam"
                                            href={mapping.buttons.header.exams}
                                            target="_self"
                                            {...dataAtributtes(actionsText.exams.plural)}
                                        >
                                            <Button>{actionsText.exams.single}</Button>
                                        </a>
                                    </>
                                )}
                            </S.ButtonContainer>
                        </S.MenuContentContainer>
                    </S.MenuList>
                )}
            </div>
        </S.Container>
    )
}

export default Menu
